module.exports = __webpack_public_path__ + "_/colorscheme/_white_red.1qq1A0R.css";


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/file-loader?name=[path][name].[sha512:hash:base64:7].css!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-colorsheme-res-resolver!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/stylus-loader!../colorscheme/_white_red.styl
// module id = 1145
// module chunks = 4